<template>
  <div id="auswertung_land">
    <div class="row">
      <div class="col-12">
        <div class="btn-toolbar mb-3" role="toolbar" aria-label="Toolbar with button groups">
          <button v-for="k in keys" type="button" class="btn btn-secondary" @click="zeige(k)" :key="k">{{ k }}</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>Derzeit: {{ current }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <div class="list-group">
          <transition-group name="fade" tag="div">
          <router-link v-for="(land, index) in ranking" :key="land.LAND" :to="'detail/'+land.LAND" class="list-group-item list-group-item-action clearfix">
            <div class="row">
              <div class="col-3">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="col-9">
                <h4 class="list-group-item-heading">{{ land.LAND }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-3 d-flex align-items-center justify-content-center">
                <img :src="land.FLAGGE" class="img-fluid" alt="flagge"/>
              </div>
              <div class="col-6">
                <p class="list-group-item-text">
                  {{ land.INTERPRET }} - {{ land.SONG }}
                  <br />
                  <span v-if="land.ESC_PUNKTE">{{ land.ESC_PUNKTE }} ESC-Punkte</span>
                  <span v-if="land.PUNKTE">{{ land.PUNKTE }} Punkte</span>
                  <span v-else>0 Punkte</span>
                </p>
              </div>
              <div class="col-3 d-flex align-items-center justify-content-center">
                  <img :src="land.ICON" class="img-fluid" alt="icon"/>
              </div>
            </div>
          </router-link>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import config from '../config'

export default {
  props: ['auswertung'],
  watch: {
    auswertung() {
      this.getData();
    }
  },
  data () {
    return {
      keys: [],
      ranking: [],
      data: [],
      mapping: {},
      current: ''
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let token = this.$store.state.token;
      axios.get(config.apiServerAdress + '/'+this.auswertung, {headers: {'x-access-token': token}})
        .then(res => {
          const data = res.data;
          const rank = [];

          for (let key in data) {
            const r = data[key];
            rank.push(r);
          }
          this.data = this.groupByArray(rank, (x) => x['GRUPPE']);

          this.generateMapping();

          this.ranking = this.data[0].values;
          this.current = this.data[0].key;
        })
        .catch(error => {
          console.log(error);
        })
    },
    groupByArray(xs, key) {
      return xs.reduce(function (rv, x) {
        let v = key instanceof Function ? key(x) : x[key];
        let el = rv.find((r) => r && r.key === v);
        if (el) {
          el.values.push(x);
        } else {
          rv.push({ key: v, values: [x] });
        }
        return rv;
      }, []);
    },
    generateMapping() {
      let k = [];
      let mapp = {};
      for (let kk in this.data) {
        let gruppe = this.data[kk].key;
        k.push(gruppe);
        mapp[gruppe] = kk;
      }
      this.keys = k;
      this.mapping = mapp;
    },
    zeige(gruppe) {
      this.ranking = this.data[this.mapping[gruppe]].values;
      this.current = gruppe;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .flagge {
    display: inline-block;
    text-align: center;
  }

  .teilnehmer {
    display: inline-block;
    margin-left: 10px;
  }

  .icon {
    display: inline-block;
  }
</style>
